<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="コンテンツ種別（部分一致）" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getUsers">検索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                           :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="コンテンツ種別" width="300" sortable>
                <template scope="scope">
                    <span v-if="scope.row.parent">{{ scope.row.parent.name }} > </span>
                    {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="fiveGChannelLinkage" label="5Gチャンネル連携" width="200" sortable>
                <template scope="scope">
                    {{ toOnOff(scope.row.fiveGChannelLinkage) }}
                </template>
            </el-table-column>
            <el-table-column label="更新日時" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="240">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 編集画面 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="150px" :rules="editFormRules" ref="editForm">
                <el-form-item label="ID" prop="id">
                    <el-input v-model="editForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="コンテンツ種別" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="ユーザ" prop="username">
                    <el-input v-model="editForm.username" disabled></el-input>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="editForm.email" disabled></el-input>
                </el-form-item>
                <el-form-item label="親コンテンツ種別">
                    <el-select v-model="editForm.parent" clearable placeholder="選択して下さい" value-key="id">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allUsers"
                                   v-if="item.id !== editForm.id"
                                   :key="item.id"
                                   :value="item"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="5Gチャンネル連携" prop="fiveGChannelLinkage">
                    <el-radio-group v-model="editForm.fiveGChannelLinkage">
                        <el-radio :label="false">OFF</el-radio>
                        <el-radio :label="true">ON</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM-dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集画面 -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" @close="closeAddForm">
            <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
                <el-form-item label="コンテンツ種別" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="ユーザ" prop="username">
                    <el-input v-model="addForm.username" auto-complete="off"></el-input>
                    <span>後から変更できません。</span>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="addForm.email" auto-complete="off"></el-input>
                    <span>後から変更できません。</span>
                </el-form-item>
                <el-form-item label="パスワード" prop="password">
                    <el-input v-model="addForm.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="親コンテンツ種別">
                    <el-select v-model="addForm.parent" clearable placeholder="選択して下さい" value-key="id">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allUsers"
                                   :key="item.id"
                                   :value="item"
                                   :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="5Gチャンネル連携" prop="fiveGChannelLinkage">
                    <el-radio-group v-model="addForm.fiveGChannelLinkage">
                        <el-radio :label="false">OFF</el-radio>
                        <el-radio :label="true">ON</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeAddForm">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import * as UserRequest from '../../api/user';
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import { formatDate } from "../../components/filters/format";
    import config from "../../config/app";


    export default {
        components: { ElOption },
        filters: { formatDate },
        data() {
            return {
                filters: {
                    name: ''
                },
                allUsers: [],
                users: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],

                // 編集
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '名前を入力してください', trigger: 'blur' }
                    ],
                    fiveGChannelLinkage: [
                        { required: true, type: "boolean", message: '5Gチャンネル連携を選択してください', trigger: 'blur' }
                    ],
                },
                editForm: {
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    parent: '',
                    fiveGChannelLinkage: false,
                },

                // 新規
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: '名前を入力してください', trigger: 'blur' }
                    ],
                    username:  [
                        { required: true, message: 'ユーザを入力してください。', trigger: 'blur' }
                    ],
                    email:  [
                        { required: true, type: 'email', message: 'メールアドレスを入力してください。', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, validator: this.validatePassword, trigger: "blur" }
                    ],
                    fiveGChannelLinkage: [
                        { required: true, type: "boolean", message: '5Gチャンネル連携を選択してください', trigger: 'blur' }
                    ],
                },
                addForm: {
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    parent: '',
                    fiveGChannelLinkage: false,
                }

            }
        },
        methods: {
            validatePassword(rule, value, callback) {
                if (value.length < 8) {
                    callback(new Error("8文字以上のパスワードを入力してください。"));
                } else if (!value.match(/[0-9]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else if (!value.match(/[a-z]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else if (!value.match(/[A-Z]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else {
                    callback();
                }
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getUsers();
            },
            getUsers() {
                let params = {
                    params: {
                        fields: "name",
                        q: this.filters.name,
                        count: config.pageCount,
                        offset: (this.page - 1) * config.pageCount,
                    }
                };
                this.listLoading = true;
                UserRequest.count()
                    .then(res => {
                        this.total = res.data.count;
                    });
                UserRequest
                    .search(params)
                    .then(res => {
                        this.users = res.data;
                        this.listLoading = false;

                        return UserRequest.all({
                            params: {
                                limit: 0
                            }
                        });
                    })
                    .then(res => {
                        this.allUsers = res.data;
                    });
            },
            handleDel: function (index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', { type: 'warning' })
                    .then(() => {
                        this.listLoading = true;

                        return UserRequest.remove(row);
                    })
                    .then(res => {
                        this.listLoading = false;
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                        this.getUsers();
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            handleAdd: function () {
                this.addFormVisible = true;
                this.addForm = {
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    parent: '',
                    fiveGChannelLinkage: false,
                };
            },
            closeAddForm() {
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.editLoading = true;
                                const params = Object.assign({}, this.editForm);
                                if (params.parent) {
                                    params.parent = params.parent.id;
                                }

                                return UserRequest.edit(this.editForm.id, params)
                            })
                            .then(res => {
                                this.editLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeEditForm();
                                this.getUsers();
                            });
                    }
                });
            },
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.addLoading = true;
                                const params = Object.assign({}, this.addForm);
                                if (params.parent) {
                                    params.parent = params.parent.id;
                                }

                                console.log(params);

                                return UserRequest.add(params)
                            })
                            .then(res => {
                                this.addLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeAddForm();
                                this.getUsers();
                            })
                            .catch(err => {
                                this.$message({
                                    message: 'エラーが発生しました。',
                                    type: 'warning'
                                });
                            });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            batchRemove: function () {
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', { type: 'warning' })
                    .then(() => {
                        this.listLoading = true;
                        return UserRequest.batchRemove(this.sels);
                    })
                    .then((res) => {
                        this.listLoading = false;
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                        this.getUsers();
                    });
            },
            toOnOff: function (value) {
                return value ? "ON" : "OFF";
            },
        },
        mounted() {
            this.getUsers();
        }
    }

</script>

<style scoped>
    .parent {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// List.vue?5e558082